import ReportsAdapter from './base';

export default class ReportTemplateSection extends ReportsAdapter {
  modelNamePlural = 'report-template-sections';
}
